/**
 * Form error scrolling.
 *
 * After a server-side form validation round-trip (HTMX swap brings the
 * form back with `.field-group.has-error` blocks rendered by Django),
 * scroll the first error into view — same UX a client-side validator used
 * to give, now driven by the server response.
 *
 * We deliberately do NOT auto-focus the offending input: focusing while
 * scrolling fights the user's eye (the page jumps, then a different input
 * grabs the caret) and on mobile pops the keyboard back up unexpectedly.
 * Scroll alone is enough for the user to see the red field and decide
 * where to click.
 *
 * Why a global ``htmx:afterSwap`` listener and not per-form code:
 * we want every form using server-side validation to get this for free,
 * with no per-page wiring. The single deterministic insertion point is
 * "right after HTMX put new content on screen".
 */

const ERROR_GROUP_SELECTOR = '.field-group.has-error';

function scrollFirstError(scope) {
    if (!scope || typeof scope.querySelector !== 'function') return;
    const firstError = scope.querySelector(ERROR_GROUP_SELECTOR);
    if (!firstError) return;

    firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

if (typeof document !== 'undefined') {
    document.addEventListener('htmx:afterSwap', function (event) {
        const target = event && event.detail && event.detail.target;
        scrollFirstError(target || document);
    });
}

export { scrollFirstError };
